<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('availableSchedule.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('availableSchedule.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
           <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="branchName">
          {{ row.branch.branch_name_en }}
        </template>
        <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(row)"
            >
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('availableSchedule.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
				width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'availableScheduleIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('booking/availableSchedule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.booking.availableSchedule.search
      },
      set(newValue) {
        this.$store.commit('booking/availableSchedule/SET_SEARCH', newValue)
        this.$store.commit('booking/availableSchedule/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { 
          title: this.$t('availableSchedule.branchName'),
          slot: 'branchName' 
        },
        { 
          title: this.$t('availableSchedule.scheduleTime'),
          key: 'schedule_time' 
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          className: 'ts-space-x-1',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('booking/availableSchedule/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('booking/availableSchedule/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('booking/availableSchedule/SET_EDIT_DATA', {})
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('booking/availableSchedule/destroy', record.schedule_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value){
      this.$store.commit('booking/availableSchedule/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('booking/availableSchedule/RESET_STATE')
    next()
  }
}
</script>
